import { render } from "./DeleteAdminDialog.vue?vue&type=template&id=33b703e8"
import script from "./DeleteAdminDialog.vue?vue&type=script&lang=js"
export * from "./DeleteAdminDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__